// extracted by css-extract-rspack-plugin
export default {"container":"rich-editor-with-warning-module__container___ezUnv"};